@let color = colorSg();
@let multipleValues = multipleValuesSg();
@let singleValue = singleValueSg();

@if (multipleValues) {
  <div class="atn-ds-table-cell-value-enum__multiple-values">
    @for (value of multipleValues; track $index) {
      <atn-ds-tag
        [color]="color"
        [text]="value"
      />
    } @empty {
      <p class="atn-ds-table-cell-value-enum__empty-label">None</p>
    }
  </div>
} @else if (singleValue) {
  <atn-ds-tag
    [color]="color"
    [text]="singleValue"
  />
}
